import { configureStore } from '@reduxjs/toolkit';
import usersSlice from './slices/user/userSlice'
import productSlice from './slices/product/productSlice'
import cartSlice from './slices/cart/cartSlice'
import orderSlice from './slices/order/orderSlice'

export const store = configureStore({
  reducer: {
      usersSlice:usersSlice,
      productSlice:productSlice,
      cartSlice:cartSlice,
      orderSlice:orderSlice

  },
});
